import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EventWebcastService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/webcasts`);
  }

  override list(urlParams: any): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/webcasts`, urlParams);
    return this.http.get<any>(url);
  }

  /** Create or update webcast (backend findOrCreate + update). */
  upsert(webcast: { company_id: string; event_id: string; webcast_by?: string; web_address?: string; toll_free_phone?: string; web_passcode?: string }): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      company_id: webcast.company_id,
      event_id: webcast.event_id,
      webcast_by: webcast.webcast_by,
      web_address: webcast.web_address,
      toll_free_phone: webcast.toll_free_phone,
      web_passcode: webcast.web_passcode,
    });
  }

  openToAudience(webcastId: string): Observable<any> {
    const url = this.baseUrl + `/${webcastId}/open_to_audience`;
    return this.http.post<any>(url, {});
  }

  validatePasscode(webcast: any, type: string): Observable<any> {
    const url = this.baseUrl + `/${webcast.id}/validate_passcode?type=${type}`;
    return this.http.post<any>(url, webcast);
  }

  startWebcast(webcastId: string, type: string): Observable<any> {
    const url = this.baseUrl + `/${webcastId}/start_webcast?type=${type}`;
    return this.http.post<any>(url, {});
  }

  startPresentation(webcastId: string, type: string): Observable<any> {
    const url = this.baseUrl + `/${webcastId}/presentation`;
    return this.http.post<any>(url, {
      type: type
    });
  }

  conclude(webcastId: string, type: string): Observable<any> {
    const url = this.baseUrl + `/${webcastId}/conclude`;
    return this.http.post<any>(url, {});
  }
}
